<template>
  <div class="userstate">
    <signModule :inputState="status >= 1" v-if="refBMDOM"></signModule>
    <p class="deltips" v-if="this.hasRegistered&&status < 1">
      如果您想取消报名，请点此按钮<el-button type="text" @click="delBMhandel"
        >删除报名</el-button
      >
    </p>
  </div>
</template>

<script>
import signModule from "../../components/signModule.vue";
import { getRegistrationInfo, delRegistration } from "../API/user";
export default {
  name: "userstate",
  components: {
    signModule,
  },
  props: {},
  data() {
    return {
      status: 0,
      hasRegistered: false,
      BMID: "",
      refBMDOM: true,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getUserState();
  },
  mounted() {},
  methods: {
    delBMhandel() {
      this.$confirm("此操作将删除该报名信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await delRegistration({ id: this.BMID });
          if (res.code != 0) {
            this.$router.push({ name: "userstate" });
          }
        })
        .catch(() => {});
    },
    async getUserState() {
      const { data: res } = await getRegistrationInfo();
      this.hasRegistered = res.data.hasRegistered
      if (res.data.hasRegistered) {
        this.status = res.data.data?.status;
        this.BMID = res.data.data?.id;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.deltips {
  padding: 0 40px;
  font-size: 15px;
  color: #999;
  @media screen and (max-width: 540px) {
    padding: 0;
  }
}
</style>
